export enum CustomerFormType {
    REGISTRATION = 1,
    EDIT_PROFILE = 2,
    GUEST = 3,
    LOGIN = 4,
    MY_ACCOUNT_EDIT = 5,
    CHANGE_PASSWORD = 6,
    EMAIL_PASS_ONLY_REGISTRATION = 7,
    EMAIL_ONLY = 8
}